import React from 'react'

import '../css/skeleton.css'
import '../css/normalize.css'
import '../css/components.css'

function Footer() {
    return (
        <div className="Footer container">
            <p>Made with <span class="heart">❤️</span> by <a href={"https://github.com/ahmadfariz"}>Ahmad Fariz Dwi Putra</a></p>
        </div>
    )
}

export default Footer
